import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs: ["en", "ar"],
    ns: ["common"],          // 👈 use 'common'
    defaultNS: "common",     // 👈 default namespace
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json', // Translation file path
    },
    detection: {
      order: ["querystring", "cookie", "sessionStorage", "navigator", "htmlTag"],
      caches: ["sessionStorage", "cookie"],
    },
  });

i18n.on("languageChanged", (lng) => {
  const isRTL = lng === "ar";
  if (typeof document !== "undefined") {
    document.documentElement.dir = isRTL ? "rtl" : "ltr";
    document.documentElement.lang = lng;
  }
});

export default i18n;
